import { Subject, takeUntil } from "rxjs";
import { IndexDbService } from "./index-db.service";
import { Injectable } from "@angular/core";
import { INDEXDBTABLE } from "@app/shared/enum/indexdb.enum";

@Injectable({
  providedIn: 'root'
})
export class DaiDbService extends IndexDbService {
  private _addUser: Subject<any> = new Subject();
  get tableName() {
    return INDEXDBTABLE.TABLEDAI
  }

  get db() {
    return this._db?.transaction(this.tableName, 'readwrite');
  }

  public cursor(keyRangeValue: any) {
    return this.db?.objectStore(this.tableName).openCursor(keyRangeValue);
  }

  get addUser$() {
    return this._addUser.pipe(takeUntil(this.onDestroy$));
  }

  constructor() {
    super();
  }

  public async setDaiImage(imageData: { daicd: string, image: string, upddate: string }) {
    return new Promise(async (resolve, _) => {
      if (!this.db) {
        console.log('can not find indexDb request');
        resolve(false);
        return;
      }

      const checkExist = await this.getDaiInfo(imageData.daicd);
      const transaction = this.db.objectStore(this.tableName);
      //
      if (checkExist) {
        const update = transaction.put(imageData);
        update.onsuccess = () => {
          resolve(true);
        };
        update.onerror = (result) => {
          console.log(result);
          resolve(false);
        };
        return;
      }
      const request = transaction.add(imageData);
      request.onsuccess = async () => {
        // request.result contains key of the added object
        console.log(`image successed`);
        this._addUser.next(imageData.daicd)
        resolve(true);
        // return await this.promiseResolve(true) as Promise<boolean>;
      }

      request.onerror = async (err) => {
        console.error(`Error to add new image: ${err}`);
        resolve(true);
        // return await this.promiseResolve(false) as Promise<boolean>;
      }
    })


  }


  public async getDaiImage(daicd: string) {
    return (await this.getDaiInfo(daicd))?.image;
  }

  public async getDaiInfo(daicd: string): Promise<{ daicd: string, image: string, upddate: string } | null> {
    return new Promise((resolve, _) => {
      if (!this.db) {
        console.log('can not find indexDb request');
        return;
        // return await this.promiseResolve('') as Promise<string>;
      }
      const imageIndex = this.db.objectStore(this.tableName)

      if (imageIndex) {
        const excuteindex = imageIndex.get(daicd);

        excuteindex.onsuccess = () => {
          resolve(excuteindex.result);

        }
        excuteindex.onerror = (event) => {
          console.log(event);
          resolve(null);
        }
      }
    })
  }
} 
